<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar"></i> 生产管理
        </el-breadcrumb-item>
        <el-breadcrumb-item>工单采集率</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="searchform" :model="searchform" label-width="80px" @keyup.enter.native="search()">
          <el-row>
            <el-col :span="7">
              <el-form-item label="工单" prop="orderno">
                <el-input v-model="searchform.orderno" style="width:100%" clearable placeholder="请输入工单" />
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="批次" prop="batchno">
                <el-input v-model="searchform.batchno" style="width:100%" clearable placeholder="请输入批次" />
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="产品编码" prop="product_code">
                <el-select v-model="searchform.product_code" style="width:100%" placeholder="请输入产品名称模糊匹配或者下拉选择"
                  :remote-method="getproductlist" filterable remote :loading="productloading">
                  <el-option v-for="item in productlist" :key="item.product_code" :label="item.product"
                    :value="item.product_code" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="生产线" prop="workline_code">
                <el-select v-model="searchform.workline_code" :remote-method="getworklinelistlistsearch"
                  placeholder="请输入生产线编码模糊匹配或者下拉选择" filterable remote style="width:100%">
                  <el-option v-for="(item, index) in worklinelist" :key="index" :label="item.workline_name"
                    :value="item.workline_code" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="生产日期区间" prop="datelist" label-width="110px">
                <el-date-picker style="width:100%" v-model="searchform.datelist" type="daterange"
                  value-format="yyyy-MM-dd" range-separator="-" start-placeholder="开始日期"
                  end-placeholder="结束日期"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="24" style="margin-left:10px">
              <el-button @click="resetForm('searchform')">重置</el-button>
              <el-button type="primary" icon="el-icon-search" @click="search()">搜索</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <br />
      <el-row type="flex" class="row-bg">
        <el-col :span="24" class="border">
          <h4>工单采集率</h4>
          <el-divider></el-divider>
          <el-table border v-loading="listLoading" element-loading-text="拼命加载中" :data="tableData" style="width:100%;"
            id="parent">
            <el-table-column prop="package_levelname" label="包装级别" min-width="65"
              show-overflow-tooltip></el-table-column>
            <el-table-column prop="package_level_produce" label="生产数量" min-width="160"
              show-overflow-tooltip></el-table-column>
            <el-table-column prop="package_level_count" label="采集数量" min-width="160"
              show-overflow-tooltip></el-table-column>
            <el-table-column prop="collection" label="采集率" min-width="110" show-overflow-tooltip></el-table-column>
            <!-- <el-table-column prop="j" label="操作人"></el-table-column> -->
          </el-table>
          <br />
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { worklinelist } from "@/api/plant";
import { samplingrate } from "@/api/plant";
import { productlist } from "@/api/base";
export default {
  mounted() {
    this.getproductlist();
    this.getworklinelistlistsearch();
    this.search()
  },
  data() {
    return {
      //基础数据
      listLoading: false,
      depart_uuid: [],
      tableData: [],
      productloading: false,
      productlist: [],
      worklinelist: [],
      //搜索表单数据
      searchform: {
        orderno: "",
        batchno: "",
        workline_code: "",
        product_code: "",
        datelist: [],
        start_time: "",
        end_time: "",
        pageIndex: 1,
        pageSize: 20
      }
    };
  },
  methods: {
    //请求表格数据
    Tabledata(obj) {
      this.listLoading = true;
      this.tableData = [];
      samplingrate(obj).then(response => {
        this.packdate(response.data);
        this.listLoading = false;
      });
    },
    getworklinelistlistsearch(value) {
      this.searchform.workline_code = "";
      worklinelist({ workshop_code: value, workorder_status: 0 }).then(
        response => {
          this.worklinelist = response.data.data;
          for (let b = 0; b < this.worklinelist.length; b++) {
            this.worklinelist[b].workline_name =
              this.worklinelist[b].workline_code +
              "|" +
              this.worklinelist[b].workline_name;
          }
        }
      );
    },
    getproductlist(value) {
      this.productlist = [];
      if (value !== "") {
        this.productloading = true;
        setTimeout(() => {
          this.productloading = false;
          productlist({ productName: value, is_traceability: 1 }).then(response => {
            this.productlist = response.data.data;
            for (var i = 0; i < this.productlist.length; i++) {
              this.productlist[i].product =
                this.productlist[i].product_code +
                "   " +
                this.productlist[i].product_name;
            }
          });
        }, 200);
      } else {
        this.productlist = [];
      }
    },
    packdate(obj) {
      // 拼装数据
      if (obj.length == 0) {
        this.tableData = [];
      } else {
        for (let i = 0; i < 5; i++) {
          this.tableData.push({});
          this.tableData[i].package_levelname = `${i + 1}级包装`;
        }
        for (let t = 0; t < this.tableData.length; t++) {
          this.tableData[t].id = t + 1;
          switch (this.tableData[t].id) {
            case 1:
              this.tableData[0].package_level_count =
                obj[0].package_level1_count;
              this.tableData[0].package_level_produce =
                obj[0].package_level1_produce;
              break;
            case 2:
              this.tableData[1].package_level_count =
                obj[0].package_level2_count;
              this.tableData[1].package_level_produce =
                obj[0].package_level2_produce;
              break;
            case 3:
              this.tableData[2].package_level_count =
                obj[0].package_level3_count;
              this.tableData[2].package_level_produce =
                obj[0].package_level3_produce;
              break;
            case 4:
              this.tableData[3].package_level_count =
                obj[0].package_level4_count;
              this.tableData[3].package_level_produce =
                obj[0].package_level4_produce;
              break;
            case 5:
              this.tableData[4].package_level_count =
                obj[0].package_level5_count;
              this.tableData[4].package_level_produce =
                obj[0].package_level5_produce;
              break;
            default:
              break;
          }
          let num =
            (this.tableData[t].package_level_count /
              this.tableData[t].package_level_produce) *
            100;
          this.tableData[t].collection = num;
          if (isNaN(this.tableData[t].collection)) {
            this.tableData[t].collection = 0;
          }
          this.tableData[t].collection =
            this.tableData[t].collection.toFixed(2) + "%";
        }
        console.log(this.tableData);
      }
    },
    //搜索事件
    search() {
      this.Tabledata({
        orderno: this.searchform.orderno,
        batchno: this.searchform.batchno,
        product_code: this.searchform.product_code,
        workline_code: this.searchform.workline_code,
        start_time:
          this.searchform.datelist == null ? null : this.searchform.datelist[0],
        end_time:
          this.searchform.datelist == null ? null : this.searchform.datelist[1]
      });
    },
    //重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.Tabledata({
        orderno: this.searchform.orderno,
        batchno: this.searchform.batchno,
        product_code: this.searchform.product_code,
        workline_code: this.searchform.workline_code,
        start_time:
          this.searchform.datelist == null ? null : this.searchform.datelist[0],
        end_time:
          this.searchform.datelist == null ? null : this.searchform.datelist[1]
      });
    },
    //分页跳转事件
    currentchange(pageIndex) {
      this.searchform.pageIndex = pageIndex;
      this.Tabledata({
        orderno: this.searchform.orderno,
        batchno: this.searchform.batchno,
        product_code: this.searchform.product_code,
        workline_code: this.searchform.workline_code,
        start_time:
          this.searchform.datelist == null ? null : this.searchform.datelist[0],
        end_time:
          this.searchform.datelist == null ? null : this.searchform.datelist[1],
        pageIndex: this.searchform.pageIndex,
        pageSize: this.searchform.pageSize
      });
    },
    //分页每页显示条数事件
    pagesize(pageSize) {
      this.searchform.pageSize = pageSize;
      this.search();
    },
    //跳转页面
    tiaozhuan() {
      this.$router.push({
        path: "/staffedit"
      });
    }
  }
};
</script>
<style scoped></style>
